import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

export const lockedPageContainerCss: CSSObject = {
  display: "flex",
  justifyContent: "center",
  background: constants.colors.brand.blue[25],
  width: "100%",
  height: "100%",
};

export const cardCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
  height: "fit-content",
  maxWidth: "18rem",
  marginTop: "3rem",
  borderRadius: "1rem",
  padding: "1.5rem 1rem",
  background: constants.colors.ui.white[50],
  justifyContent: "center",
  alignItems: "center",

  [`@media (min-width: ${constants.breakpoints.Breakpoints.xs}px)`]: {
    maxWidth: "32.5rem",
  },

  [`@media (min-width: ${constants.breakpoints.Breakpoints.sm}px)`]: {
    flexDirection: "row",
    maxWidth: "45rem",
    alignItems: "flex-start",
  },
};

export const infoCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "0.5rem",

  [`@media (min-width: ${constants.breakpoints.Breakpoints.sm}px)`]: {
    alignItems: "flex-start",
  },
};

export const titleCss: CSSObject = {
  fontSize: "1.5rem",
  fontWeight: 700,
  textAlign: "center",
  color: constants.colors.ui.neutral[700],
  lineHeight: "1.995rem",
  marginBottom: "0.5rem",

  [`@media (min-width: ${constants.breakpoints.Breakpoints.sm}px)`]: {
    textAlign: "left",
  },
};

export const descriptionCss: CSSObject = {
  fontSize: "1.125rem",
  lineHeight: "1.4625rem",
  textAlign: "center",
  fontWeight: 400,
  color: constants.colors.ui.neutral[600],
  marginBottom: "1rem",

  [`@media (min-width: ${constants.breakpoints.Breakpoints.sm}px)`]: {
    textAlign: "left",
  },
};

export const anchorCss = {
  root: {
    width: "fit-content",
    padding: "0.5rem",
    background: constants.colors.ui.core[700],
    color: constants.colors.ui.white[50],
    borderRadius: "0.5rem",
    textDecoration: "none",

    "> div": {
      display: "flex",
      alignItems: "center",
    },
  },
};

export const externalLinkIconCss = {
  root: {
    width: "1rem",
    height: "1rem",
    marginLeft: "0.5rem",

    path: {
      strokeWidth: "0.25rem",
    },
  },
};
